import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IAgencyNumbers, IConfigurationsState } from '../store/configurations.types'
import { getConfigurationsSelector } from '../selectors/configurations.selector'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { agencyNumberConfigToAgencyNumber } from '../utils/configurations.util'
import { ConfigurationsConstants } from '../store/configurations.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* saveAgencyNumber() {
  const { agencyNumberConfig }: IConfigurationsState = yield select(getConfigurationsSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)

  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)

    const newAgencyNumber: IAgencyNumbers = agencyNumberConfigToAgencyNumber(agencyNumberConfig)
    const pcrDocUpdated = { ...pcrDoc, agencyNumber: newAgencyNumber }

    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
  } catch (e) {
    yield put(throwPcrException(`saveAgencyNumber() error: ${e}`))
  }
}

export function* saveAgencyNumberSaga() {
  yield takeLatest([ConfigurationsConstants.SAVE_AGENCY_NUMBER], performWithMutexHOG, saveAgencyNumber)
}
